import { VStack } from "native-base";
import { TouchableWithoutFeedback } from "react-native";

import { useAppSelector } from "@/hooks/application/store";

type ComponentProps = {
  children: JSX.Element;
  onPress: () => void;
};

const ClickProtectedWrapper = ({ children, onPress }: ComponentProps) => {
  const { logged } = useAppSelector((store) => store.auth);
  return (
    <TouchableWithoutFeedback onPress={!logged ? onPress : () => {}}>
      <VStack pointerEvents={!logged ? "box-only" : "auto"}>{children}</VStack>
    </TouchableWithoutFeedback>
  );
};

export default ClickProtectedWrapper;
